import { StarknetHTLCPublicClient } from './PublicClient.js';
import { userLock } from './wallet/userLock.js';
import { refund } from './wallet/refund.js';
import { redeemSolver } from './wallet/redeemSolver.js';
import { buildUserLockTx } from './wallet/buildUserLockTx.js';
import { buildRefundTx } from './wallet/buildRefundTx.js';
import { buildRedeemSolverTx } from './wallet/buildRedeemSolverTx.js';
import { buildApproveTx } from './wallet/buildApproveTx.js';
export class StarknetHTLCWalletClient extends StarknetHTLCPublicClient {
    constructor(config) {
        super(config);
        this.signer = config.signer;
    }
    async userLock(params) {
        return userLock(this.signer, params);
    }
    async refund(params) {
        return refund(this.signer, params);
    }
    async redeemSolver(params) {
        return redeemSolver(this.signer, params);
    }
    // ── Transaction Builders ──────────────────────────────────────────
    buildUserLockTx(params) {
        return buildUserLockTx(params);
    }
    buildRefundTx(params) {
        return buildRefundTx(params);
    }
    buildRedeemSolverTx(params) {
        return buildRedeemSolverTx(params);
    }
    buildApproveTx(params) {
        return buildApproveTx(params);
    }
}
